import { MEMBERSTATE, ROOMSSTATE, USERSSTATE } from '..'
import { RoomView } from '../../constants/enums'
import {
    canJoinMemberRoom,
    canWatchMemberWebcams,
} from '../../mfcLogic/memberAccess'
import {
    findMemberRoomByOwner,
    isOwnerWebcamRoom,
} from '../../mfcLogic/memberRooms'
import { getModalState } from '../getState'
import { slugToID } from './users'

export const pmPreview = { id: null as number | null }

const viewerLevel = () => USERSSTATE.users[slugToID['me']]?.level

export const canViewerWatchMemberCams = () =>
    canWatchMemberWebcams(viewerLevel())

export const isMemberCam = (id: number) => !!USERSSTATE.users[id]?.hasMemberCam

const isInsideOwnerWebcamRoom = (id: number) => {
    const room = ROOMSSTATE.rooms[id]
    if (!room?.isMemberRoom || room.joinDenied || room.memberRoomClosed) {
        return false
    }
    const memberRoom = findMemberRoomByOwner(MEMBERSTATE.members.rooms, id)
    return (
        isOwnerWebcamRoom(memberRoom) &&
        canJoinMemberRoom(memberRoom, viewerLevel())
    )
}

export const isMemberWebcamRoom = (id: number) =>
    !!ROOMSSTATE.rooms[id]?.isMemberRoom &&
    isOwnerWebcamRoom(findMemberRoomByOwner(MEMBERSTATE.members.rooms, id))

// the viewer's own owner-webcam room: their camera is the room's video
export const isOwnWebcamRoom = (id: number) =>
    !!id && id === slugToID['me'] && isMemberWebcamRoom(id)

const isRoomCamShown = (id: number) => {
    const {
        show,
        id: floaterId,
        roomView,
        hideVideo,
    } = getModalState().floating_room
    return show && floaterId === id && roomView === RoomView.Room && !hideVideo
}

export const canPlayMemberCam = (id: number) =>
    id !== slugToID['me'] &&
    isMemberCam(id) &&
    ((pmPreview.id === id && canViewerWatchMemberCams()) ||
        (isInsideOwnerWebcamRoom(id) && isRoomCamShown(id)))
